import { VEHICLE_SELECTOR, PLACES, ROUTE } from '../../lib/Constants';

// actions
import {
  APP_DETECT_MOBILE,
  APP_CAPTURE_STATE,
  APP_PARSE_TTP,
  APP_UPDATE_LOADING,
  APP_SET_INITIAL_STATE,
  APP_TOGGLE_EASTER_EGG,
  updateDevice,
  parseAppTTP,
  APP_UPDATE_COMPONENT_HEIGHT,
  updateComponentHeight,
} from './actions';

const App = (
  state = {
    isMobile: false,
    windowWidth: 0,
    windowHeight: 0,
    prevState: {},
    locale: '',
    region: '',
    globalGlossary: {},
    isLoading: true,
    easterEgg: false,
    componentHeights: [
      { component: VEHICLE_SELECTOR, height: 0 },
      { component: PLACES, height: 0 },
      { component: ROUTE, height: 0 },
    ],
  },
  action,
) => {
  switch (action.type) {
    case APP_UPDATE_COMPONENT_HEIGHT:
      return {
        ...state,
        componentHeights: [...updateComponentHeight(state, action)],
      };
    case APP_DETECT_MOBILE:
      return {
        ...state,
        ...updateDevice(),
      };
    case APP_CAPTURE_STATE:
      return {
        ...state,
        prevState: {
          ...action.prevState,
        },
      };
    case APP_SET_INITIAL_STATE:
      return {
        ...state,
        unit: {
          ...action.app.unit,
        },
        locale: action.app.locale,
        region: action.app.region,
        language: action.app.language,
      };
    case APP_PARSE_TTP:
      parseAppTTP();
      return state;
    case APP_UPDATE_LOADING:
      return {
        ...state,
        isLoading: action.isLoading,
      };
    case APP_TOGGLE_EASTER_EGG:
      return {
        ...state,
        easterEgg: action.easterEgg,
      };
    default:
      return state;
  }
};

export default App;
